
const getAppSettingsData = (settingsData) => settingsData.get('app');
const getClientSettingsData = (settingsData) => settingsData.get('client');


export {getAppSettingsData, getClientSettingsData}